import deepGet from '../helpers/deep-get';
import deepMerge from 'deepmerge';

const translated = {};
let translations = {};

export default {
    install(Vue) {
        const configuration = Vue.prototype.$configuration;
        const locales = window['searchbooster'].api.locales;
        Vue.prototype.$t = (key, placeholders, fallback) => {
            /**
             * Определяем объект переводов
             */
            if (Object.keys(translations).length === 0) {
                translations = deepMerge(
                    locales[configuration.locale],
                    configuration.locales[configuration.locale] || {},
                );
            }
            /**
             * Если еще не загружены переводы, не делаем поиск в пустом объекте.
             * Иначе не найдем перевод и закешируем в качестве перевода key.
             * И когда переводы загрузятся и сработает реактивность, получим закешированное key вместо перевода.
             */
            if (Object.keys(translations || []).length === 0) {
                return fallback || key;
            }
            if (translated[key] !== undefined && placeholders === undefined) {
                return translated[key];
            }
            translated[key] = deepGet(translations, key) || fallback || key;
            if (placeholders) {
                const iterableEntries = Array.isArray(placeholders) ? placeholders.entries() : Object.entries(placeholders);
                for (const [index, iterator] of iterableEntries) {
                    translated[key] = translated[key].replaceAll(`{${index}}`, iterator);
                }
            }
            return translated[key];
        };
    },
};